// components/export/ExportExpedition.js
import React, { useState } from 'react';
import { Button, message, Space, Card, Tooltip } from 'antd';
import { CloudUploadOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { requestExportProgress } from '../../services/exportProgress';
import ExportProgress from '../shared/ExportProgress';

const ExportExpedition = () => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(null);

  const handleExport = async () => {
    if (loading) return;
    setLoading(true);
    setProgress({ stage: 'starting', table: 'Expédition', percent: 0 });
    try {
      const result = await requestExportProgress(`${process.env.REACT_APP_API_BASE_URL}/exped/export/dbf`, { progress: true }, setProgress);
      setProgress(result);
      
      if (result.success) {
        message.success('Export des journaux d\'expédition complété avec succès');
      } else {
        message.error('Échec de l\'export: ' + result.message);
      }
    } catch (error) {
      setProgress(previous => ({ ...previous, stage: 'failed', message: error.message }));
      console.error('Erreur d\'export:', error);
      message.error('Échec de l\'export: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card 
      title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          Export Journal d'Expédition
          <Tooltip title="Les fichiers sont exportés dans le dossier /site/expedition sur le serveur FTP">
            <InfoCircleOutlined style={{ marginLeft: 8 }} />
          </Tooltip>
        </div>
      } 
      style={{ height: '100%' }}
    >
      <ExportProgress progress={progress} title="Expédition" />
      <Space direction="vertical" style={{ width: '100%' }}>
        <p>
          Exporter les journaux d'expédition validés des 3 derniers jours vers le serveur FTP.
          Le fichier JRNEXP.dbf sera créé dans le dossier expedition.
        </p>
        <Button
          type="primary"
          icon={<CloudUploadOutlined />}
          loading={loading}
          onClick={handleExport}
          size="large"
          block
        >
          {loading ? 'Exportation en Cours...' : "Démarrer l'export"}
        </Button>
      </Space>
    </Card>
  );
};

export default ExportExpedition;